import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { ModuleItemPreviewData } from '../../../models/module-item-preview-data';

@Injectable({
  providedIn: 'root',
})
export class PreviewService {
  previewData$: BehaviorSubject<ModuleItemPreviewData>;

  constructor() {
    this.previewData$ = new BehaviorSubject<ModuleItemPreviewData>({});
  }

  setPreviewData(previewData: ModuleItemPreviewData) {
    this.previewData$.next(previewData);
  }
}
